<template>
  <div class="page-form page-base">
    <h3 class="title">合同信息查看</h3>
    <div class="form-container">
      <div class="tools">
        <form-button @click="$router.go(-1)">返回</form-button>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="100px"
        disabled
        :model="conditions"
        :rules="rules"
        :show-message="false"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="合同单号">
              <el-input v-model="conditions.cntrno" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="合同编号" prop="cnrtln">
              <el-input v-model="conditions.cnrtln" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="合同名称" prop="cntrname">
              <el-select v-model="conditions.cntrname" clearable placeholder="">
                <el-option
                  v-for="item in selectDataOptions['contractName']"
                  :key="item.VALUE_ID"
                  :label="item.VALUE_KT"
                  :value="item.VALUE_ID"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户编号" prop="customer">
              <wly-input
                v-model="conditions.customer"
                input-type="customer"
                @enter="handleEnter"
              />
              <!-- <el-input v-model="conditions.customer" suffix-icon="el-icon-more" placeholder="请输入" @focus="openDialog" /> -->
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input v-model="conditions.name1" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select v-model="conditions.customer_type" disabled placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.value"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元" prop="sal_center">
              <el-select v-model="conditions.sal_center" placeholder="" @change="salChange">
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="计划类型" prop="plan_type">
              <el-select v-model="conditions.plan_type" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0002']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="合同年度" prop="contr_year">
              <el-date-picker
                v-model="conditions.contr_year"
                type="year"
                format="yyyy"
                value-format="yyyy"
                :clearable="false"
                @change="contrYearChange"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基地">
              <el-input v-model="conditions.zzfld00003e" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="地址">
              <el-input v-model="conditions.address" type="textarea" rows="4" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input v-model="conditions.remark" type="textarea" rows="4" />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="合同金额/数量" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="起始日期" prop="cotr_start">
              <el-date-picker
                v-model="conditions.cotr_start"
                type="date"
                value-format="yyyyMMdd"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="到期日期" prop="cont_end">
              <el-date-picker
                v-model="conditions.cont_end"
                type="date"
                value-format="yyyyMMdd"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="终止日期" prop="cont_close">
              <el-date-picker
                v-model="conditions.cont_close"
                type="date"
                value-format="yyyyMMdd"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="签约方式" prop="sign_status">
              <el-select v-model="conditions.sign_status" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0010']"
                  :key="item.value"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="总数量(件)">
              <el-input v-model="conditions.cotr_qty" disabled placeholder="" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="总金额(万元)">
              <el-input v-model="conditions.cotr_amt" disabled placeholder="" />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="合同状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input v-model="conditions.uname" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建时间">
              <el-date-picker v-model="conditions.datum" value-format="yyyyMMdd" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-input v-model="conditions.status" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input v-model="conditions.audit_comment" type="textarea" rows="4" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="销售区域设置" :custome-config="() => vxeShowCustom('gridOptionArea')">
        <vxe-grid
          ref="gridOptionArea"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionArea.columns"
          :data="gridOptionArea.data"
        >
          <template #REGION="{ row }">
            <span>{{ row.REGN_NAME }}</span>
          </template>
          <template #CITY_CODE="{ row }">
            <span>{{ row.CITY_NAME }}</span>
          </template>
          <template #STREET="{ row }">
            <span>{{ row.STREET_NAME }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="销售渠道设置" :show-custome="false">
        <el-checkbox-group v-model="chanelCheckList">
          <el-row>
            <el-col v-for="item in selectDataOptions['contractQd']" :key="item.CHANNEL" :lg="6" :md="8">
              <el-checkbox disabled :label="item.CHANNEL">{{ item.CHL_NAME }}</el-checkbox>
            </el-col>
          </el-row>
        </el-checkbox-group>
      </TableCommon>

      <TableCommon title="存货分类设置" :show-custome="false">
        <el-checkbox-group v-model="chflCheckList">
          <el-row>
            <el-col v-for="item in selectDataOptions['contractChfl']" :key="item.VALUE_ID" :lg="6" :md="8">
              <el-checkbox disabled :label="item.VALUE_ID">{{ item.VALUE_KT }}</el-checkbox>
            </el-col>
          </el-row>
        </el-checkbox-group>
      </TableCommon>

      <!-- <TableCommon title="存货分类按月明细" :custome-config="() => vxeShowCustom('gridOptionChfl')">
        <vxe-grid
          ref="gridOptionChfl"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          max-height="500"
          align="center"
          size="mini"
          :edit-rules="chflRule"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionChfl.columns"
          :data="gridOptionChfl.data"
        >
          <template #CHFL="{ row }">
            <span>{{ filterChfl(row.CHFL) }}</span>
          </template>
          <template #QUANTITY="{ row }">
            <span>{{ row.QUANTITY }}</span>
          </template>
          <template #AMOUNT="{ row }">
            <span>{{ row.AMOUNT }}</span>

          </template>
          <template #AMOUNT_OUTER="{ row }">
            <span>{{ row.AMOUNT_OUTER }}</span>

          </template>
          <template #QUANTITY_OUTER="{ row }">
            <span>{{ row.QUANTITY_OUTER }}</span>

          </template>
          <template #REMARK="{ row }">
            <span>{{ row.REMARK }}</span>

          </template>
        </vxe-grid>
      </TableCommon> -->
    </div>

    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      title="客户选择"
      width="70%"
    >
      <client-select v-if="showDialog" ref="clientSelect" />
      <div slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiSapClientFindInfo } from '@/api/common'

import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { mapGetters } from 'vuex'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import { apiGetContractDetail, apiGetContractQd, apiContractCreate, apiGetContractNy, apiGetContractName, apiGetContractChfl } from '@/api/sap/contract'
import { getArea } from '@/api/sap/common-sap'
export default {
  components: { ClientSelect },
  data() {
    const rules = {
      cnrtln: [{ required: true, message: '请输入合同编码', trigger: 'blur' }],
      cntrname: [{ required: true, message: '请选择合同名称', trigger: 'change' }],
      sal_center: [{ required: true, message: '请选择营销单元', trigger: 'change' }],
      // plan_type: [{ required: true, message: '请选择计划类型', trigger: 'change' }],
      customer: [{ required: true, message: '请选择客户', trigger: 'change' }],
      // cont_close: [{ required: true, message: '请选择终止日期', trigger: 'change' }],
      cont_end: [{ required: true, message: '请选择到期日期', trigger: 'change' }],
      cotr_start: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
      sign_status: [{ required: true, message: '请选择签约方式', trigger: 'change' }],
      contr_year: [{ required: true, message: '请选择合同年度', trigger: 'change' }]
    }
    return {
      rules,
      chflRule: {
        QUANTITY: [{ required: true }]
      },
      showDialog: false,
      loading: false,
      errorList: [],
      mode: 'add',
      conditions: {
        uname: '',
        datum: '',
        status: '新建',
        stacode: 'E001',
        cntrno: '',
        cnrtln: '',
        cntrname: '',
        customer: '',
        name1: '',
        customer_type: '',
        sal_center: '',
        sign_status: '',
        cotr_start: '',
        cont_end: '',
        cont_close: '',
        contr_year: new Date().getFullYear().toString(),
        cotr_qty: '',
        cotr_amt: '',
        address: '',
        plan_type: '',
        zzfld00003e: '',
        zzfld00003e_textview: '',
        remark: '',
        audit_comment: ''
      },
      chanelCheckList: [],
      chflCheckList: [],
      selectDataOptions: {},
      gridOptionArea: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { field: 'REGION', title: '经营区域/省份/直销市', slots: { default: 'REGION' }},
          { field: 'CITY_CODE', title: '经营区域/城市/地区', slots: { default: 'CITY_CODE' }},
          { field: 'STREET', title: '经营区域/区县', slots: { default: 'STREET' }}
        ],
        data: []
      },
      gridOptionChfl: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'CHFL', title: '存货分类', slots: { default: 'CHFL' }},
          { field: 'YEAR_MONTH', title: '年月' },
          { field: 'UNIT', title: '单位' },
          { field: 'QUANTITY', title: '计划内数量(件)', slots: { default: 'QUANTITY' }, editRender: {}},
          { field: 'AMOUNT', title: '金额(万元)', slots: { default: 'AMOUNT' }},
          { field: 'QUANTITY_OUTER', title: '计划外数量(件)', slots: { default: 'QUANTITY_OUTER' }},
          { field: 'AMOUNT_OUTER', title: '计划外金额(万元)', slots: { default: 'AMOUNT_OUTER' }},
          { field: 'REMARK', title: '备注', slots: { default: 'REMARK' }}
        ],
        data: []
      },
      contract: {}
    }
  },
  computed: {
    ...mapGetters(['role', 'customerInfo']),
    isEdit() {
      return this.conditions.stacode === 'E001'
    }
  },
  watch: {
    // chflCheckList: {
    //   handler(nV, oV) {
    //     const diffence = oV.concat(nV).filter((v, i, arr) => arr.indexOf(v) === arr.lastIndexOf(v))
    //     if (oV.length > nV.length) {
    //       // 取消了某个存货分类，需要删除对应的明细
    //       // 获取需要删除的存货分类
    //       this.delChflDetail(diffence)
    //     } else if (oV.length < nV.length) {
    //       // 增加了某个存货分类，需要生成对应的明细
    //       this.generateDetail(diffence)
    //     }
    //   },
    //   deep: true
    // },
    'gridOptionChfl.data': {
      handler(nV, oV) {
        // cotrQty数量 , cotrAmt金额
        this.conditions.cotr_qty = nV.reduce((prev, curr) => prev + (+curr.QUANTITY), 0)
        this.conditions.cotr_amt = nV.reduce((prev, curr) => prev + (+curr.AMOUNT), 0)
      },
      deep: true
    }
  },
  created() {
    this.init()
    const { id } = this.$route.query
    if (id) {
      this.mode = 'edit'
      // 请求合同详情接口
      this.getDetail(id)
    } else {
      if (this.role.ROLE === 'WLY001') {
        this.conditions.customer = this.customerInfo.info.partner
        this.conditions.name1 = this.customerInfo.info.name_org1
        this.conditions.customer_type = this.customerInfo.info.zzfld000016
        this.selectDataOptions['orgList'] = this.customerInfo.yxdy
      }
      this.findByYear()
      this.$watch('chflCheckList', (nV, oV) => {
        const diffence = oV.concat(nV).filter((v, i, arr) => arr.indexOf(v) === arr.lastIndexOf(v))
        if (oV.length > nV.length) {
          // 取消了某个存货分类，需要删除对应的明细
          // 获取需要删除的存货分类
          this.delChflDetail(diffence)
        } else if (oV.length < nV.length) {
          // 增加了某个存货分类，需要生成对应的明细
          this.generateDetail(diffence)
        }
      }, { deep: true })
    }
  },
  methods: {
    newPage() {
      this.$router.replace('/wly/contract/edit')
    },
    async getDetail(id) {
      const params = {
        iv_cntrno: id,
        mv_role: this.role.USER_BP
      }
      const res = await apiGetContractDetail(params)
      Object.keys(res.LS_HEAD).forEach(key => {
        this.conditions[key.toLowerCase()] = res.LS_HEAD[key]
      })
      this.findByYear()
      this.initCustome()
      this.gridOptionArea.data = res.LT_ITMA
      this.gridOptionChfl.data = res.LT_ITME
      this.chflCheckList = res.LT_ITMD.filter(v => v.SEL === 'X').map(v => v.VALUE_ID)
      this.chanelCheckList = res.LT_ITMB.filter(v => v.SEL === 'X').map(v => v.CHANNEL)
    },
    filterChfl(chfl) {
      const str = this.selectDataOptions['contractChfl'].find(v => v.VALUE_ID === chfl)?.VALUE_KT
      return str
    },
    // 初始化客户信息
    async initCustome() {
      const params = { rt_partner: [{
        SIGN: 'I',
        OPTION: 'EQ',
        LOW: this.conditions.customer,
        HIGH: ''
      }], page: 1, pagesize: 50 }
      // 当前登录账号和角色
      params.partner = this.role.USER_BP
      params.role = this.role.ROLE
      const { data } = await apiSapClientFindInfo(params)
      this.$set(this.selectDataOptions, 'orgList', data[0].yxdy)
      this.$set(this.selectDataOptions, 'addressList', data[0].address)
    },
    async init() {
      this.getSelectDictDataOrigin('A0002')
      this.getSelectDictDataOrigin('A0048')
      // 销售渠道
      this.getSelectDictDataOrigin('A0050')
      this.getSelectDictDataOrigin('A0010')
      this.getSelectDictDataOrigin('A0009')
      this.getContractName()
      this.getContractChfl()
      this.getContractQd()
      this.conditions.uname = this.role.login_user
      this.conditions.datum = this.$utilsCommon.parseTime(
        new Date().getTime(),
        '{y}-{m}-{d}'
      )
      // 初始化省份
      getArea().then(res => {
        this.selectDataOptions['regionList'] = res.DATA
      })
    },
    // 合同名称
    async getContractName() {
      const { DATA } = await apiGetContractName()
      this.$set(this.selectDataOptions, 'contractName', DATA)
    },
    // 存货分类
    async getContractChfl() {
      const { DATA } = await apiGetContractChfl()
      this.$set(this.selectDataOptions, 'contractChfl', DATA)
    },
    // 渠道类型
    async getContractQd() {
      const { DATA } = await apiGetContractQd()
      this.$set(this.selectDataOptions, 'contractQd', DATA)
    },
    openDialog(e) {
      e.target.blur()
      this.showDialog = true
    },
    async handleSubmit() {
      const data = await this.$refs.clientSelect.submitForm()
      if (!data) return

      this.conditions.customer = data.partner
      this.conditions.name1 = data.name_org1
      this.conditions.customer_type = data.zzfld000016
      this.$set(this.selectDataOptions, 'orgList', data.orgList)
      this.$set(this.selectDataOptions, 'addressList', data.addressList)
      this.showDialog = false
    },
    // 控件回车
    async handleEnter(e, type, data) {
      // console.log('handleEnter', type, data)
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return

      switch (type) {
        case 'customer':
          this.conditions.customer = data.partner
          this.conditions.name1 = data.name_org1
          this.conditions.customer_type = data.zzfld000016
          this.$set(this.selectDataOptions, 'orgList', data.orgList)
          this.$set(this.selectDataOptions, 'addressList', data.addressList)
          break
      }
    },
    salChange(e) {
      const checkedData = this.selectDataOptions.orgList.find(v => v.zzfld00001h === e)
      this.conditions.zzfld00003e = checkedData.mc_short_jd
    },
    // 合同年度变化
    async contrYearChange(e) {
      // 1.查询财年
      await this.findByYear()
      // 2. 如果有明细改变明细的时间
      if (this.gridOptionChfl.data.length) {
        // 先获取存货分类，再更新每个对应的分类
        const chflList = [...new Set(this.gridOptionChfl.data.map(v => v.chfl))]
        this.updateDetail(chflList)
      }
    },
    // 变更明细
    updateDetail(chfls) {
      chfls.forEach(fl => {
        const index = this.gridOptionChfl.data.findIndex(v => v.chfl === fl)
        let { year, month } = this.contract
        Array.from({ length: 12 }).forEach((v, i) => {
          this.gridOptionChfl.data[index].YEAR_MONTH = `${year}-${month >= 10 ? month : '0' + month}`
          month++
          if (month > 12) {
            year += 1
          }
        })
      })
    },
    // 删除多个明细
    delChflDetail([chfl]) {
      Array.from({ length: 12 }).forEach(v => {
        const index = this.gridOptionChfl.data.findIndex(v => v.VALUE_ID === chfl)
        this.gridOptionChfl.data.splice(index, 1)
      })
    },
    // 生成明细
    generateDetail([chfl]) {
      let { year, month } = this.contract
      year -= 0
      month -= 0
      Array.from({ length: 12 }).forEach((v, i) => {
        const data = {
          CHFL: chfl,
          YEAR_MONTH: `${year}-${month >= 10 ? month : '0' + month}`,
          UNIT: '箱',
          QUANTITY: '',
          AMOUNT: '',
          QUANTITY_OUTER: '',
          AMOUNT_OUTER: ''
        }
        this.gridOptionChfl.data.unshift(data)
        month++
        if (month > 12) {
          year += 1
          month = 1
        }
      })
    },
    async changeArea(e, type, row) {
      if (type === 'region') {
        // 省变化查询市
        if (e) {
          row.REGN_NAME = row.regionList.find(v => v.BLAND === e).BEZEI
          const { DATA } = await getArea(e, 'city')
          row.cityList = DATA
        } else {
          row.cityList = []
        }
        row.streetList = []
      } else if (type === 'city') {
        // 市变化查询去区县
        if (e) {
          row.CITY_NAME = row.cityList.find(v => v.CITY_CODE === e).CITY_NAME
          const { DATA } = await getArea(e, 'street')
          row.streetList = DATA
        } else {
          row.streetList = []
        }
      } else {
        row.STREET_NAME = row.streetList.find(v => v.STREET === e).STREET_NAME
      }
    },
    insertArea() {
      const row = {
        REGION: '',
        CITY_CODE: '',
        STREET: '',
        cityList: [],
        regionList: this.selectDataOptions['regionList'],
        streetList: []
      }
      this.gridOptionArea.data.unshift(row)
    },
    removeArea() {
      const checkList = this.$refs.gridOptionArea.getCheckboxRecords()

      // 直接删除
      checkList.forEach(item => {
        const index = this.gridOptionArea.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptionArea.data.splice(index, 1)
      })
    },
    saveData(mode) {
      this.$refs.form.validate(async(val, err) => {
        if (val) {
          const itmb = this.selectDataOptions.contractQd.filter(v => this.chanelCheckList.includes(v.CHANNEL)).map(v => {
            v.sel = 'X'
            return v
          })
          const itmd = this.selectDataOptions.contractChfl.filter(v => this.chflCheckList.includes(v.VALUE_ID)).map(v => {
            v.sel = 'X'
            return v
          })
          this.errorList = []
          const validKey = Object.keys(this.chflRule)
          const isvalide = this.gridOptionChfl.data.every(item => validKey.every(key => item[key].toString().length))
          if (!isvalide) {
            return this.$message.warning('请输入必输项：计划内数量！')
          }

          const params = {
            iv_mode: mode,
            user_bp: this.role.USER_BP,
            head: this.conditions,
            itma: this.gridOptionArea.data,
            itmb: itmb,
            itmd: itmd,
            itme: this.gridOptionChfl.data
          }
          const res = await apiContractCreate(params)
          if (res.MSGTYPE === 'S') {
            this.errorList = []
            this.$message.success(res.MESSAGE)
            Object.keys(res.DATA.HEAD).forEach(key => {
              this.conditions[key.toLowerCase()] = res.DATA.HEAD[key]
            })
            this.gridOptionArea.data = res.DATA.ITMA
            this.gridOptionChfl.data = res.DATA.ITME
          } else {
            this.errorList.push(res.MESSAGE)
          }
        } else {
          this.errorList = [`有${Object.values(err).length}项必填项目未填写`]
          return false
        }
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 获取财年时间
    async findByYear() {
      const { DATA } = await apiGetContractNy({ gjahr: this.conditions.contr_year })
      this.contract = {
        year: DATA.GJAHR,
        month: DATA.MONAT
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/contract-manage/check/contractDetailCheck.vue